import * as React from 'react';
import '@swc/helpers';
import '@grandvisionhq/utils';
import '../../../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import '../../../../../models/adyen/payment-type.js';
import '@grandvisionhq/icons';
import '../../../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../../../models/googlePay/types.js';
import '../../../../../models/payment/types.js';
import '../../../../../models/paypal/context.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/forms';
import { OneyContainer } from '../../../containers/Adyen/Oney/containers/OneyContainer.js';
import { getPaymentSelectOptions } from '../../../utils/get-payment-select-options.js';

const Oney = ({ config , onChange  })=>{
    const oneyOptions = React.useMemo(()=>getPaymentSelectOptions(config)
    , [
        config
    ]);
    const onHandleChange = React.useCallback((selectedInstallment)=>{
        if (selectedInstallment.label && selectedInstallment.value) {
            onChange({
                type: selectedInstallment.value
            }, true);
        } else {
            onChange({}, false);
        }
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(OneyContainer, {
        options: oneyOptions,
        onChange: onHandleChange
    });
};

export { Oney };
//# sourceMappingURL=Oney.js.map
